// Where riders book. /book is the booking page; /book-ride and /book-preview still work (they send you to /book).
export const BOOK_PATH = '/book';
